module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAMAAADHVLbdAAAAZlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+Vn2moAAAAIXRSTlMAmcPsXPvy78/Lo7KtdnBJQhzz2MrEt5eJgGZlVzAtEwupLckiAAAAaUlEQVQI103HRxKDMBQE0TFfmexsE+f+lwQVJURvuh6UZc4qyAkTKhrw7Ac8efEXcFdr/2ByGENctG3/dABerDvZXaDne3fFDgWj4XQzDVrW5FlI3lskY2k+dY/DHjlPCMtbqqSBEuZEbQyyD8RaD0X1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-header-instagram.png
// module id = 291
// module chunks = 114276838955818 159515537771391